import { getABTest, isABTestEnabled } from '@/shared/lib/abTest';

// TODO: fix cross dependecies
import { useBalanceStore } from '../../../balance';
import { useCurrentUser } from './useCurrentUser';

export const useIsDemoView = () => {
  const { data: user } = useCurrentUser();
  const { hasTrialPlan } = useBalanceStore();

  const demoProjectsTrialABTest = getABTest({
    testName: ['demo_project'],
    tests: user?.feature_groups,
  });

  const isTestEnabled = isABTestEnabled(demoProjectsTrialABTest);

  const isDemoView = hasTrialPlan && isTestEnabled;

  return { isDemoView, isUserInDemoAB: isTestEnabled };
};
